import { IconType } from "react-icons";
import { Input, InputContainer } from "./index.styled";


interface InputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  icon?: IconType;
  color?: string;
  suffix?: string;
  disabled?: boolean;
}
const InputComponent: React.FC<InputProps> = ({ value, onChange, placeholder, type='text', icon: Icon, color='black', suffix, disabled }) => {
  return (
    <InputContainer color={color}>
      {Icon && <Icon />}
      <Input 
        type={type}
        value={value} 
        onChange={(e) => onChange(e.target.value)} 
        placeholder={placeholder}
        disabled={disabled}
      />
      {suffix && <span className="suffix-span">{suffix}</span>}
    </InputContainer>
  );
}

export default InputComponent;
